import Cookies from "universal-cookie";
import AgentIcon from '@mui/icons-material/SupervisorAccount';
import { green, red, blue, orange } from '@mui/material/colors';
import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import IconButton from '@mui/material/IconButton';
import Edit from '@mui/icons-material/Edit';
import LocationOn from '@mui/icons-material/LocationOn';
import Chip from '@mui/material/Chip';
import Divider from '@mui/material/Divider';
import { grey } from '@mui/material/colors';
import EmailIcon from '@mui/icons-material/Email';
import IpIcon from '@mui/icons-material/SmartScreen';
import TimerIcon from '@mui/icons-material/Timer';
import PhoneIcon from '@mui/icons-material/Phone';
import NoteIcon from '@mui/icons-material/Note';
import HistoryIcon from '@mui/icons-material/History';
import StatusIcon from '@mui/icons-material/CheckCircle';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import './UserDrawer.css';
import { collection, doc, getDoc, onSnapshot } from 'firebase/firestore';
import { db } from '../lib/firebaseConfig';
import { useAuth, auth } from "../hooks/auth";


function UserDrawer() {
  const labels = [
    { title: 'User', color: grey[500] },
    { title: 'Customer', color: green[500] },
    { title: 'Prospect', color: orange[500] },
    { title: 'Lead', color: red[500] },
    { title: 'Qualified', color: blue[500] },
    // Ajoutez ici d'autres labels si nécessaire
  ];


  const defaultLabel = labels.find(label => label.title === 'User');
  const [selectedLabels, setSelectedLabels] = useState([defaultLabel]);
  const [serviceNote, setServiceNote] = useState('Last contacted on 01/01/2023');
  const [userData, setUserData] = useState(null);
  const cookies = new Cookies();
  const currentUserId = cookies.get("uuid");
  const [activeUser, setActiveUser] = useState(0);

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        // Fetch the user data from Firestore using the appropriate collection and document IDs
        const userDocRef = doc(db, 'chatUsers', currentUserId); // Replace 'userId' with the actual user ID from Firebase
        const userDocSnapshot = await getDoc(userDocRef);
        if (userDocSnapshot.exists()) {
          const userData = userDocSnapshot.data();
          setUserData(userData);
          console.log('User Data:', userData); // Log the retrieved user data
        }
      } catch (error) {
        console.error('Error fetching user data:', error);
      }
    };

    fetchUserData();
  }, []);

  useEffect(() => {

    const updateUserStatus = (snapshot) => {
      // Recherche de l'utilisateur actuel dans le snapshot
      const currentUserData = snapshot.docs.find((doc) => doc.id === currentUserId)?.data();
      if (currentUserData) {
        setUserData((prevUserData) => ({
          ...prevUserData,
          isActive: currentUserData.isActive
        }));
      }
    };
    
  
    const unsubscribe = onSnapshot(collection(db, 'chatUsers'), (snapshot) => {
      updateUserStatus(snapshot);
      const activeUser = true
    });
  
    return () => unsubscribe();
  }, []);
  
  if (!userData) {
    return null;
  }



  return (
    <Card className="user-drawer" style={{maxWidth: '350px'}}>
      <Box sx={{ p: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Avatar variant="rounded" src="avatar1.jpg" />
          <Stack spacing={0.5} sx={{ ml: 1 }}>
            <Typography fontWeight={700} color="white">{userData.name}</Typography>
            <Typography variant="body2" color="white" sx={{display: userData.location ? 'default' : 'none'}}>
              <LocationOn sx={{color: red[500]}} /> {userData.location}
            </Typography>
          </Stack>
        </Box>
        <IconButton>
          <Edit sx={{ fontSize: 14, color: 'white'}} />
        </IconButton>
      </Box>
      <Divider />
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        sx={{ px: 2, py: 1, bgcolor: 'transparent'}}
      >
        <Chip label={userData.isActive ? 'Active' : 'Offline'} sx={{bgcolor: userData.isActive ? "#22c55e" : "#dc2626", width: '100%', color: 'white', borderRadius: '5px', boxShadow: userData.isActive ? '0 0 10px 1px #22c55e8c' : '0 0 10px 1px #ff000063'}} />
        

      </Stack>
      <Divider color={'white'} style={{margin:'10px'}}/>
      <Box sx={{ p: 2 }}>
        <Typography variant="h6" fontWeight="bold" color="white" sx={{mb: 1}}>
          User Information
        </Typography>
        <Box sx={{ display: userData.email ? 'flex' : 'none', alignItems: 'center', mb: 1 }}>
          <EmailIcon sx={{color: 'white', mr: 1}} />
          <Typography variant="body2" color="white">
            {userData.email}
          </Typography>
        </Box>

        

        <Box sx={{ display: userData.ip ? 'flex' : 'none', alignItems: 'center', mb: 1 }}>
          <IpIcon sx={{color: 'white', mr: 1}} />
          <Typography variant="body2" color="white">
          {userData.ip}
          </Typography>
        </Box>
        
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
          <TimerIcon sx={{color: 'white', mr: 1}} />
          <Typography variant="body2" color="white">
            Active since: 2 hours
          </Typography>
        </Box>
      </Box>
      <Divider color={'white'} style={{margin:'10px'}}/>

      <Box sx={{ p: 2 }}>
      <Typography variant="h6" fontWeight="bold" color="white" sx={{mb: 1}}>
        CRM Options
      </Typography>
      <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: 2, flexDirection: 'column', gap: 1 }}>
      <Autocomplete
        disableClearable
        sx={{width:'100%', bgcolor: 'white'}}
        options={labels}
        getOptionLabel={(option) => option.title}
        onChange={(event, value) => setSelectedLabels(value ? [value] : [])}
        value={selectedLabels[0]} 
        renderInput={(params) => <TextField {...params} />}
        />

        <Box 
          sx={{ 
            display: 'flex', 
            flexWrap: 'wrap',
            justifyContent: 'center',
            gap: 1,
            mb: 2
          }}
        >
          {selectedLabels.map((label, index) => (
            <Chip
              key={index}
              label={label.title}
              style={{ backgroundColor: label.color, color: 'white', margin: '5px' }}
            />
          ))}
        </Box>
      </Box>



        <Box sx={{ display: 'none', alignItems: 'center', mb: 1 }}>
          <PhoneIcon sx={{color: 'white', mr: 1}} />
          <Typography variant="body2" color="white">
            +(123) 456-7890
          </Typography>
        </Box>
       
        
        <Box sx={{ display: 'none', alignItems: 'center', mb: 1 }}>
          <StatusIcon sx={{color: 'white', mr: 1}} />
          <Typography variant="body2" color="white">
            Account Status: {userData.isActive ? 'Active' : 'Offline'}
          </Typography>
        </Box>
      </Box>
    </Card>
  );
}

export default UserDrawer;
